import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

function Maintenance() {
  const navigate = useNavigate();
  const [errorInfo, setErrorInfo] = useState(null);

  useEffect(() => {
    const errData = sessionStorage.getItem('lastError');
    if (errData) {
      try {
        setErrorInfo(JSON.parse(errData));
      } catch {
        setErrorInfo({ message: "에러 데이터를 읽을 수 없어요." });
      }
    }
  }, []);

  const goMove = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div className="container">
      <div id="system_inspection" className="page">
        <div className="content-wrap">
          <div className="img-box">
            <img src="/images/products/img-inspection.png" alt="점검아이콘" />
          </div>

          <p className="t-22-multi fw-b fc-h ta-c">
            시스템 점검 중이에요
            <br />이용에 불편을 드려 죄송해요
          </p>

          <p className="t-16-multi fc-s ta-c">
            더 나은 서비스로 돌아올게요.
          </p>

          {/* [개발용] 에러 로그 표시 영역 */}
          {errorInfo && (
            <div
              className="dev-error-box"
              style={{
                background: '#fff8f8',
                border: '1px solid #ffcccc',
                borderRadius: '10px',
                padding: '16px',
                marginTop: '20px',
                color: '#a00',
                fontFamily: 'monospace',
                maxWidth: '100%',
                overflowX: 'auto',
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                userSelect: 'text',
                maxHeight: '40vh',
                boxSizing: 'border-box',
              }}
            >
              <h3 style={{ fontSize: '16px', marginBottom: '8px' }}>[개발용] 에러 정보</h3>
              <div>
                <p><strong>Status:</strong> {errorInfo.status}</p>
                <p><strong>Message:</strong> {errorInfo.message}</p>
                <p><strong>URL:</strong> {errorInfo.url}</p>
                <p><strong>Time:</strong> {errorInfo.time}</p>
              </div>

              {/* 혹시 전체 JSON을 보고 싶을 때 */}
              <details style={{ marginTop: '10px' }}>
                <summary style={{ cursor: 'pointer', color: '#555' }}>전체 JSON 보기</summary>
                <pre
                  style={{
                    background: '#fff',
                    border: '1px solid #eee',
                    padding: '10px',
                    marginTop: '8px',
                    overflowX: 'auto',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {JSON.stringify(errorInfo, null, 2)}
                </pre>
              </details>
            </div>
          )}
          {/* [개발용 블록 끝] */}
        </div>
      </div>

      <div className="tab-bar-btn-group fixed">
        <div className="btn-group">
          <button
            onClick={goMove}
            className="btn-md filled primary"
            type="button"
          >
            홈으로 이동
          </button>
        </div>
      </div>
    </div>
  );
}

export default Maintenance;
